import { AddressContent } from '@printdeal/address-frontend';
import { Address } from '@printdeal/address-frontend/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  address: Address;
  quantity?: number;
  showEmail?: boolean;
}

const OrderAddressContent = ({
  address,
  quantity,
  showEmail = false,
}: Props) => (
  <div data-hj-suppress>
    <AddressContent
      address={address}
      showFirstAndLastName
      showEmail={showEmail}
      display="inline"
    />
    {typeof quantity !== 'undefined' && (
      <>
        {' '}
        <small className="pd-text-dim-500">
          (
          <FormattedMessage
            id="general.lineItem.quantityCount"
            defaultMessage="{quantity} {quantity, plural, one {piece} other {pieces}}"
            values={{ quantity }}
          />
          )
        </small>
      </>
    )}
  </div>
);

export default OrderAddressContent;
